import { render, staticRenderFns } from "./ArchivedApplicants.vue?vue&type=template&id=f220e9c2&"
import script from "./ArchivedApplicants.vue?vue&type=script&lang=js&"
export * from "./ArchivedApplicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports